import * as React from "react";

import { TextButton } from "./Button";
import { Icon } from "./Icon";

interface GoBackButtonType {
  className?: string;
  onClick?: (e: React.MouseEvent) => void;
  text: string | React.ReactNode;
  link?: string;
  type?: "primary";
  hasIcon?: boolean;
}

export const GoBackButton: React.FC<GoBackButtonType> = ({
  className,
  onClick,
  text,
  type,
  hasIcon = true,
}) => {
  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    onClick!(e);
  };
  return (
    <TextButton
      buttontype={type}
      data-test="backToListing"
      data-testid="btn-back"
      className={className}
      onClick={onClick && handleClick}
    >
      {hasIcon && <Icon type="back" />}
      {text}
    </TextButton>
  );
};
